module.exports = __webpack_public_path__ + "static/media/c3po.fea35428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/c3po.jpg
// module id = 33
// module chunks = 0